
const INITIALIZED = '[app]initialized';
const SET_NETWORK_ERROR = '[app]set.network.error';
const SET_NETWORK_ERROR_INFO = '[app]set.network.error.info';
const SET_OFFLINE_MODE = '[app]set.offline.mode';
const SET_OFFLINE_REASON = '[app]set.offline.reason';


export {INITIALIZED, SET_NETWORK_ERROR, SET_OFFLINE_MODE, SET_OFFLINE_REASON, SET_NETWORK_ERROR_INFO}